import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

export const useColumnView = <T>(columnItems: T[] = []) => {
  const theme = useTheme();
  const matchesLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const numColumns = useMemo(() => {
    let columnCount = 2;
    if (matchesLarge) {
      columnCount = 4;
    } else if (matchesMobile) {
      columnCount = 1;
    }
    return columnCount;
  }, [matchesLarge, matchesMobile]);

  const itemCountPerColumn = useMemo(
    () => Math.ceil(columnItems.length / numColumns),
    [columnItems.length, numColumns]
  );

  const items = useMemo(() => {
    const items: T[][] = [];
    for (let i = 0; i < numColumns; i++) {
      items.push(
        columnItems.slice(
          i * itemCountPerColumn,
          i * itemCountPerColumn + itemCountPerColumn
        )
      );
    }

    return items;
  }, [columnItems, itemCountPerColumn, numColumns]);

  return items;

  return items;
};
